import {
  any, date, string, number,
} from '@sda/sdk/helpers/types.bitmasks';

export const AffiliateMask = {
  campaign: string,
  impressions: number,
  medium: string,
  name: string,
  productOrderData: any,
  orders: number,
  source: string,
  showId: string,
  tickets: number,

  createdAt: date,
  updatedAt: date,
};
